import { Component, OnInit } from '@angular/core';
import { EventService } from 'src/app/_services/generatedServices';
import { EventSearchParameters, EventConferenceItemListing } from 'src/app/_models/generatedModels';
import { SettingsProvider } from 'src/app/_services/settingsProvider.service';
import { AuthenticationService } from "../../_services/authentication.service";

@Component({
  selector: 'upcoming-events-list',
  templateUrl: 'upcoming-events-list-component.component.html',
})

export class UpcomingEventsListComponent implements OnInit {
  initialized: boolean;
  items: EventConferenceItemListing[];
  currentPage = 0;
  pageSize = 15;
  resultCount = 0;
  params: EventSearchParameters;
  searching: boolean = false;

  constructor(private eventService: EventService, public auth: AuthenticationService, private settings: SettingsProvider) {}

  ngOnInit(): void {
    this.params = new EventSearchParameters();
    this.params.onlyShowFuture = true;

    if (this.settings.applicationName === 'BehaviorLive') {
      this.params.excludeIfConference = true;
    } else {
      this.params.excludeIfConference = false;
    }

    this.search(true);
  }

  search(resetPaging: boolean) {
    this.searching = true;
    if (resetPaging) {
      this.currentPage = 0;
    }
    this.items = [];

    this.eventService.getAllEventsPaged(this.currentPage, this.pageSize, this.params).subscribe((pagedResult) => {
      this.currentPage = pagedResult.currentPage;
      this.pageSize = pagedResult.pageSize;
      this.resultCount = pagedResult.rowCount;
      this.items = pagedResult.results;

      this.searching = false;
      this.initialized = true;
    });
  }

  paginate(event) {
    this.currentPage = event.page;
    this.pageSize = event.rows;
    this.search(false);
  }
}
